import ReactPixel from 'react-facebook-pixel';
import { Environments } from '@monorepo/client-types';
import { Application, SupportedCurrencies } from '@monorepo/types';

// Ensure environment variables are properly cast as strings
const project: Application =
  (import.meta.env.VITE_PROJECT as Application) || Application.TTP;
const pixelThe5Id: string | undefined = import.meta.env
  .VITE_FACEBOOK_PIXEL_THE5_ID;
const pixelTTPId: string | undefined = import.meta.env
  .VITE_FACEBOOK_PIXEL_TTP_ID;

// Determine the correct pixel ID based on the project
const pixelId: string | undefined =
  project === Application.TTP ? pixelTTPId : pixelThe5Id;

const isProduction = import.meta.env.VITE_APP_ENV === Environments.Production;

let isInitialized = false;

export const initFacebookPixel = () => {
  if (isProduction && !isInitialized) {
    if (!pixelId) {
      console.warn('Facebook Pixel ID is missing.');
      return;
    }
    ReactPixel.init(pixelId, undefined, {
      autoConfig: true,
      debug: false,
    });
    ReactPixel.pageView();
    isInitialized = true;
  }
};

// Track an add to cart event
export const trackMetaPixelAddToCart = (
  amount: number,
  currency: SupportedCurrencies,
  contentName?: string,
  contentId?: string,
) => {
  if (!pixelId) {
    console.warn('Cannot track add to cart: Facebook Pixel ID is missing.');
    return;
  }

  if (!isInitialized) {
    console.warn('Facebook Pixel is not initialized. Initializing now...');
    initFacebookPixel();
  }

  ReactPixel.track('AddToCart', {
    value: amount,
    currency,
    content_name: contentName,
    content_ids: contentId ? [contentId] : undefined,
    content_type: 'product',
  });
};

// Track a purchase event
export const trackMetaPixelPurchase = (
  amount: number,
  currency: SupportedCurrencies,
  orderId?: string,
) => {
  if (!pixelId) {
    console.warn('Cannot track purchase: Facebook Pixel ID is missing.');
    return;
  }

  if (!isInitialized) {
    console.warn('Facebook Pixel is not initialized. Initializing now...');
    initFacebookPixel();
  }

  ReactPixel.track('Purchase', {
    value: amount,
    currency,
    order_id: orderId,
  });
};
